import { getProductsSelfData } from '../services/replenishment';

const productsSelfDataQuery = {
  key: 'productsSelfData',
  query: getProductsSelfData,
};

export { productsSelfDataQuery };
